import React, { useEffect, useRef, useState } from 'react';
import { View, Text, StyleSheet, BackHandler, StatusBar, TouchableOpacity, KeyboardAvoidingView, ScrollView, Dimensions, Platform, Share } from 'react-native';

import Colors from '../constants/Colors';
import { Ionicons, } from "@expo/vector-icons"

import { WebView } from 'react-native-webview';
import { useMediaQuery } from 'native-base';
import * as MediaLibrary from "expo-media-library";
import AwesomeAlert from 'react-native-awesome-alerts';
import * as FileSystem from 'expo-file-system';
import moment from 'moment';
import { Alert } from 'react-native';







const WEB = (props) => {

    const [ERROR, setError] = useState(false);

    const webViewRef = useRef(null)
    function handleBackButtonClick() {
        webViewRef.current.goBack();
        return true;
    }

    useEffect(() => {
        BackHandler.addEventListener("hardwareBackPress", handleBackButtonClick);
        return () => {
            BackHandler.removeEventListener("hardwareBackPress", handleBackButtonClick);
        };
    }, []);

    //  console.log(props.route.params.type);
    const imageUrl = { uri: props.route.params.addressweb }
    const handleDownload = async () => {
         let date = moment().format('YYYYMMDDhhmmss')
         
        let fileUri = FileSystem.documentDirectory + `${date}.${props.route.params.type}`;
        try {
            const res = await FileSystem.downloadAsync(imageUrl.uri, fileUri)
            saveImage(res.uri)
        } catch (err) {
            console.log("FS Err: ", err)
        }
    }

    const saveImage = async (fileUri) => {

         const { status } = await MediaLibrary.requestPermissionsAsync();
           
        
         if (status === "granted") {
             try {
                 const asset = await MediaLibrary.createAssetAsync(fileUri);
                 const album = await MediaLibrary.getAlbumAsync('Download');
                 if (album == null) {
                     await MediaLibrary.createAlbumAsync('Download', asset, false);
                 } else {
                     await MediaLibrary.addAssetsToAlbumAsync([asset], album, false);
                     Alert.alert("موفق!", "فایل با موفقیت ذخیره شد", [
                    
                        { text: "باشه", onPress: () => props.navigation.pop() }
                    ]);
                 }
             } catch (err) {
                 console.log("Save err: ", err)
             }
         } else if (status === "denied") {
             alert("please allow permissions to download")
         }





            // if (status === "granted") {
            //     const asset = await MediaLibrary.createAssetAsync(uri)
            //     await MediaLibrary.createAlbumAsync("Download", asset, false)
            //     console.log(asset);
            // }
        
        
            // 
            // console.log(permissions); // { canAskAgain: true, expires: "never", granted: true, status: "granted" }
        
            // try {
            //     await MediaLibrary.createAssetAsync(uri)
            //     // await MediaLibrary.saveToLibraryAsync(localUri); // Same error message
            // } catch (e) {
            //     console.log(e) //  [Error: Unable to copy file into external storage.]
            // }
        
    
        // try {
        //   // Request device storage access permission
        //   const { status } = await MediaLibrary.requestPermissionsAsync();
        //   console.log(uri);
        //   if (status === "granted") {
        //   // Save image to media library
        //     await MediaLibrary.saveToLibraryAsync(uri);
      
        //     console.log("Image successfully saved");
        //   }
        // } catch (error) {
        //   console.log(error);
        // }
      };
  
   
  
      const shareOptions = {
          message: props.route.params.addressweb, // Note that according to the documentation at least one of "message" or "url" fields is required
          
        };
  
     const onSharePress = () => Share.share(shareOptions)



    const [isSmallScreen] = useMediaQuery({
        // minHeight: 280,
        // maxHeight: 480,
        maxWidth: 500
    });


    return (


        <View style={{
            width: isSmallScreen ? "100%" : 500,
            height: "100%",
            marginLeft: isSmallScreen ? 0 : "35%",
            backgroundColor: Colors.background,
            position: Platform.OS == "web" ? "fixed" : "relative"
        }}>


            <View style={styles.viewHeader}>
                <StatusBar backgroundColor={Colors.primary} />
                <TouchableOpacity onPress={() => props.navigation.goBack()} style={styles.menu}   >
                    <Ionicons name="arrow-forward-outline" size={25} color={Colors.background} />
                </TouchableOpacity>

                <TouchableOpacity onPress={() => props.navigation.goBack()} style={styles.textheader}>
                    <Text style={{ fontFamily: "MontserratBold", fontSize: 17, color: Colors.background, padding: "5%" }}>
                        بستن
                    </Text>
                </TouchableOpacity>

                <TouchableOpacity onPress={() => setError(true)} style={styles.textheader1}>
                <Ionicons name="ellipsis-vertical" size={25} color={Colors.background} />
                </TouchableOpacity>

            </View>

            {Platform.OS == "web" ?
                <iframe id="iFrameExample"
                    style={{ height: "100%", width: "100%" }}
                    title="iFrame Example"
                    src={props.route.params.addressweb}>
                </iframe>
                :
                <WebView
                    ref={webViewRef}

                    style={{ width: "100%", height: 500 }}


                    source={{ uri: props.route.params.addressweb }}
                />

            }


<AwesomeAlert
                    show={ERROR}
                    showProgress={false}
                    title={"انتخاب کنید"}
                    //message={"نسخه شما قدیمی است لطفا نسخه جدید را نصب کنید. "}
                    closeOnTouchOutside={true}
                    closeOnHardwareBackPress={false}
                    showCancelButton={true}
                    showConfirmButton={true}
                    cancelText="ذخیره در گالری"
                    confirmText="اشتراک گذاری"
                    confirmButtonColor={Colors.success}
                    onCancelPressed={() => {
                    //    saveImage(props.route.params.addressweb)
                    handleDownload()
                       setError(false)
                    }}
                    onConfirmPressed={() => {
                        // download()
                        onSharePress()
                        setError(false)
                    }}
                    titleStyle={{ fontFamily: "MontserratBold", fontSize: 18, color: "red" }}
                    messageStyle={{ fontFamily: "Montserrat", fontSize: 15 }}
                    confirmButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13, marginTop: Platform.OS == "web" ? 5 : 0 }}
                    confirmButtonStyle={{ width: "45%", height: 40, alignItems: "center" }}
                    cancelButtonStyle={{ width: "45%", height: 40, backgroundColor: Colors.primary, alignItems: "center" }}
                    cancelButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13, marginTop: Platform.OS == "web" ? 5 : 0 }}
                />







        </View>




    );
}

const styles = StyleSheet.create({

    viewContainer: {
        width: "100%",
        height: "100%",
        backgroundColor: Colors.background,
        position: Platform.OS == "web" ? "fixed" : "relative"
    },

    viewHeader: {
        flexDirection: "row",
        width: "100%",
        height: Platform.OS == "web" ? 60 : 80,
        backgroundColor: Colors.primary,
    },

    menu: {
        backgroundColor: Colors.primary,
        width: 40,
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: 15,
        top: Platform.OS == "web" ? "15%" : "35%",

    },
    textheader: {
        backgroundColor: Colors.primary,
        width: 100,
        height: 40,
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        right: "12%",
        top: Platform.OS == "web" ? "15%" : "35%"
    },
    textheader1: {
        backgroundColor: Colors.primary,
        width: 100,
        height: 40,
        alignItems: "flex-start",
        justifyContent: "flex-end",
        position: "absolute",
        left: "3%",
        top: Platform.OS == "web" ? "15%" : "35%"
    },

    text: {
        fontFamily: "Montserrat",
        fontSize: 14,
        color: Colors.secondText3,
        textAlign: "right",
        marginTop: 30,
    },

})




export default WEB